"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePointer = void 0;
const proj_1 = require("ol/proj");
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function usePointer() {
    const map = useOLMap_1.useOLMap();
    const [position, setPosition] = react_1.useState(null);
    react_1.useEffect(() => {
        const onPointerMove = (e) => {
            setPosition(proj_1.toLonLat(e.coordinate));
        };
        map.on('pointermove', onPointerMove);
        return () => {
            map.un('pointermove', onPointerMove);
        };
    }, [map, setPosition]);
    return react_1.useMemo(() => ({
        position,
    }), [position]);
}
exports.usePointer = usePointer;
//# sourceMappingURL=usePointer.js.map